import { RoyalMailProvider } from '~/lib/consts/providers';

const GetServiceTypes = (provider: string, profile: string | undefined | null) => {
  switch (profile?.toUpperCase()) {
    case 'POSTOFFICE.UK.LIVE':
    case 'POSTOFFICE.UK.DEVELOPMENT':
      return [{ text: 'All', value: 'All' }];
  }

  switch (provider?.toUpperCase()) {
    case RoyalMailProvider:
      return [{ text: 'All', value: 'All' }];
    default:
      return [
        { text: 'All', value: 'All' },
        { text: 'Collection', value: 'Collection' },
        { text: 'Drop Off', value: 'Shop' }
      ];
  }
};

export default GetServiceTypes;
